import React from 'react';
import { Modal, styled } from '@mui/material';
import { useModalContext } from './ModalContext';
import CreateIntegration from './CreateIntegration';
import { IntegrationTypeCard } from './IntegrationTypeCard';
import { GreenhouseApplicationForm } from './GreenhouseApplicationForm';
import { GreenhouseOnboardingForm } from './GreenhouseOnboardingForm';
import { SeedTalentIntegrationForm } from './SeedTalentIntegrationForm';
import { fixedEventTypeFor } from './seedTalentIntegrationTypes';

const ModalContainer = styled('div')(({ theme }) => ({
  position: 'absolute',
  backgroundColor: '#eee',
  border: '2px solid #000',
  boxShadow: theme.palette.shadows.primary,
  padding: theme.spacing(4, 4, 4),
  width: '85%',
  maxHeight: '90%',
  overflowY: 'auto',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
}));

const Sections = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '24px'
});

// Shared by IntegrationsToolbar (create) and IntegrationsTable (edit). Renders
// the type selector first, then routes to the Greenhouse Recruiting or
// Onboarding form, falling back to the raw JSON editor for every other
// integration type.
const IntegrationModal = ({ children }) => {
  const {
    isOpen,
    onClose,
    uiType,
    formState,
    setFormState,
    onSubmitIntegration,
    isUpdate
  } = useModalContext();

  return (
    <Modal onClose={onClose} open={isOpen}>
      <ModalContainer>
        <Sections>
          <IntegrationTypeCard />
          {uiType === 'greenhouse-recruiting' ? (
            <GreenhouseApplicationForm />
          ) : uiType === 'greenhouse-onboarding' ? (
            <GreenhouseOnboardingForm />
          ) : fixedEventTypeFor(uiType) ? (
            <SeedTalentIntegrationForm />
          ) : (
            <CreateIntegration
              formState={formState}
              isUpdate={isUpdate}
              onSubmitIntegration={onSubmitIntegration}
              setFormState={setFormState}
            />
          )}
          {children}
        </Sections>
      </ModalContainer>
    </Modal>
  );
};

export default IntegrationModal;
